module.exports = __webpack_public_path__ + "img/alandislands.969c3f05.svg";